import Repository from './Repository'

const resource = '/auth'

export default {
  login (email, password, remember) {
    let payload = {
      email: email,
      password: password,
      remember: remember
    }
    return Repository.post(`${resource}/login`, payload)
  },
  logout () {
    return Repository.get(`${resource}/logout`)
  },
  passwordRequest (email, url) {
    let payload = {
      email: email,
      url: url
    }
    return Repository.post(`${resource}/password/email`, payload)
  },
  passwordReset (token, email, password, passwordConfirmation) {
    let payload = {
      token: token,
      email: email,
      password: password,
      password_confirmation: passwordConfirmation
    }
    return Repository.post(`${resource}/password/reset`, payload)
  }
}
